import { z } from 'zod';
import { paginationSchema } from './common.js';
export const auditQuerySchema = paginationSchema.extend({
    actorId: z.string().uuid().optional(),
    action: z
        .union([z.string(), z.array(z.string())])
        .optional()
        .transform((v) => (v === undefined ? undefined : Array.isArray(v) ? v : [v])),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
